// Formats a Date (or date string) into the value expected by
// <input type="datetime-local">, using LOCAL time (IST) instead of UTC.
// Using .toISOString() here is wrong because it returns UTC, causing
// a 5:30 hour offset for users in India.
export const toLocalInputValue = (date) => {
  const d = date ? new Date(date) : new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
